import styled from "styled-components";
import color from "../../../../constants/color";

export const Content = styled.div`
  padding: 0 24px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const SectionTitle = styled.h3`
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  color: #000000;
  margin: 0 0 20px 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #e0e0e0;
`;

export const Row = styled.div<{ template?: string }>`
  display: grid;
  grid-template-columns: ${({ template }) => template ?? "1fr"};
  gap: 0;
  width: 100%;
  padding: 20px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-of-type {
    border-bottom: none;
  }
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0 16px;
  border-right: 1px solid #e5e7eb;
  min-width: 0;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    border-right: none;
    padding-right: 0;
  }
`;

export const Label = styled.span`
  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  color: #666666;
  line-height: 1.4;
`;

export const Value = styled.span`
  font-family: Inter;
  font-size: 14px;
  font-weight: 400;
  color: #1a1a1a;
  line-height: 1.5;
  word-break: break-word;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #e0e0e0;
`;

export const Button = styled.button`
  background: #2d5bff;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 32px;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background: #1e4ed8;
  }
`;
